import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const PatientDxEmr = ({ diagnosis, emr }) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th className="table-col-width">Title</th>
        <th className="details-th">Details</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <strong>Dx Codes</strong>
        </td>
        <td>
          {diagnosis.bloodGlucose && (
            <>
              <span className="subheader">Blood Glucose:</span>
              <span>{diagnosis.bloodGlucose}</span>
            </>
          )}
          {diagnosis.bloodPressure && (
            <>
              <span className="subheader">Blood Pressure:</span>
              <span>{diagnosis.bloodPressure}</span>
            </>
          )}
          {diagnosis.weight && (
            <>
              <span className="subheader">Weight:</span>
              <span>{diagnosis.weight}</span>
            </>
          )}
          {diagnosis.pulmonary && (
            <>
              <span className="subheader">Pulmonary:</span>
              <span>{diagnosis.pulmonary}</span>
            </>
          )}
          {diagnosis.sleep && (
            <>
              <span className="subheader">Sleep:</span>
              <span>{diagnosis.sleep}</span>
            </>
          )}
        </td>
      </tr>
      <tr>
        <td>
          <strong>EMR</strong>
        </td>
        <td>
          {emr.account && (
            <>
              <span className="subheader">Patient MRN ID:</span>
              <span>{emr.account}</span>
            </>
          )}
          {emr.billing && (
            <>
              <span className="subheader">Billing:</span>
              <span>{emr.billing ? 'Yes' : 'No'}</span>
            </>
          )}
          {emr.billingCycle && (
            <>
              <span className="subheader">Billing Cycle:</span>
              <span>{emr.billingCycle}</span>
            </>
          )}
          {emr.emrId1 && (
            <>
              <span className="subheader">ID 1:</span>
              <span>{emr.emrId1}</span>
            </>
          )}
          {emr.emrId2 && (
            <>
              <span className="subheader">ID 2:</span>
              <span>{emr.emrId2}</span>
            </>
          )}
          {emr.supervisingProviderId && (
            <>
              <span className="subheader">Supervising Provider:</span>
              <span>{emr.supervisingProviderId}</span>
            </>
          )}
          {emr.renderingProviderId && (
            <>
              <span className="subheader">Rendering Provider:</span>
              <span>{emr.renderingProviderId}</span>
            </>
          )}
          {emr.name && (
            <>
              <span className="subheader">EMR Name:</span>
              <span>{emr.name}</span>
            </>
          )}
          {emr.readingsFlag && (
            <>
              <span className="subheader">Readings:</span>
              <span>{emr.readingsFlag ? 'Yes' : 'No'}</span>
            </>
          )}
          {emr.reports && (
            <>
              <span className="subheader">Report:</span>
              <span>{emr.reports}</span>
            </>
          )}
        </td>
      </tr>
    </tbody>
  </Table>
);

PatientDxEmr.propTypes = {
  diagnosis: PropTypes.shape(),
  emr: PropTypes.shape(),
};

export default PatientDxEmr;
